import React from 'react';
import OpenPlatformPage from '../../features/open-platform/pages/OpenPlatformPage';

const AdminOpenPlatform = () => <OpenPlatformPage />;

export default AdminOpenPlatform;


